import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as ImgDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/ImgBlock/ImgBlockDefaultData";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const createImageBlock = ({
  signedId,
  alt = "",
  baseData = ImgDefaultData,
  placeholder = "",
  styles = {},
}: {
  signedId: string;
  alt?: string;
  baseData?: BaseBlock;
  placeholder?: string;
  styles?: Record<string, StyleValue>;
}): BaseBlock => ({
  ...baseData,
  id: uuidv4(),
  props: {
    ...baseData.props,
    image: {
      ...baseData.props.image,
      prop: "other",
      value: {
        ...(baseData?.props?.image?.value as Record<string, string>),
        signed_id: signedId,
        placeholder,
      },
    },
    alt: {
      ...baseData.props.alt,
      prop: "other",
      value: alt,
    },
    styles: {
      ...baseData?.props?.styles,
      prop: "styles",
      type: "styles",
      value: {
        ...(baseData?.props?.styles?.value as Record<string, StyleValue>),
        ...styles,
      },
    },
  },
});
